<section>
  <ggi-journey-client-header></ggi-journey-client-header>
  <div class="container">
    <router-outlet (activate)="onActivate()"></router-outlet>
  </div>
  <ggi-journey-modal-new-invitation
    *ngIf="modal"
    [visitId]="visitId"
  ></ggi-journey-modal-new-invitation>
</section>
